import e from"react";import{AuthClientContext as t}from"./auth-client-context.js";const r=({children:r,...o})=>e.createElement(t.Provider,{value:o},r);export{r as AuthClientContextProvider};
